const colors = {
  loadingComponentColor: "#D2D2D2",
};

export default colors;
